<template>
  <div class="header">
    <div class="container-fluid">
      <div class="card attendance-card" style="margin-top: 50px">
        <Header />
        <div class="card-body">
          <div class="attendance-toolbar mb-4">
            <div class="filter-group">
              <label class="filter-label">Schedule Date</label>
              <div class="date-range">
                <v-date-picker
                  v-model="filters.start_date"
                  type="date"
                  value-type="date"
                  format="DD-MM-YYYY"
                  placeholder="Start date"
                />
                <span class="date-separator">to</span>
                <v-date-picker
                  v-model="filters.end_date"
                  type="date"
                  value-type="date"
                  format="DD-MM-YYYY"
                  placeholder="End date"
                  :disabled="!filters.start_date"
                  :disabled-date="disableEndDate"
                />
              </div>
            </div>

            <div class="filter-group year-filter">
              <label class="filter-label">Year</label>
              <v-select
                v-model="filters.year"
                :options="yearOptions"
                label="label"
                :reduce="(option) => option.id"
                :disabled="!!filters.start_date"
                placeholder="All years"
              />
            </div>

            <div class="filter-group search-filter">
              <label class="filter-label">Search</label>
              <b-form-input v-model="filters.search" placeholder="Training title..." />
            </div>

            <b-button variant="outline-danger" @click="clearFilter" class="clear-button">
              <span class="fe fe-x"></span>
              Clear
            </b-button>
          </div>

          <DataTable
            :rows="attendances.data"
            :total="attendances.totalItems"
            :showing-from="showingFrom"
            :showing-to="showingTo"
            :page="filters.page"
            :page-size="filters.pageSize"
            :loading="isLoading"
            @sort-change="onSortChange"
            @page-change="onPageChange"
            @per-page-change="onPerPageChange"
            @page-change-from-bv="onPageChangeFromBv"
            @view-event="handleViewDetailEvent"
          />

          <EventModal
            :modal-id="'event-modal'"
            :data="detailEvent"
            :is-loading="isModalEventLoading"
            @close="showModal = false"
            @open-submit-attendance-modal="handleOpenSubmitAttendanceModal"
            @view-attendance="handleViewDetailAttendance"
          />

          <SubmitAttendanceModal
            :modal-id="'submit-attendance-modal'"
            :data="scheduleData"
            :profile="profileData"
            :is-submitting="isSubmitAttendanceLoading"
            @close="showModal = false"
            @submit-attendance="handleSubmitAttendance"
          />

          <AttendanceModal :modal-id="'attendance-modal'" :data="detailAttendance" @close="showModal = false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logic from "./main.logic";
import Header from "./components/header.vue";
import ModalFilter from "./modal/filter-modal.vue";
import DataTable from "./table/data-table.vue";
import EventModal from "./modal/event-modal.vue";
import SubmitAttendanceModal from "./modal/submit-attendance-modal.vue";
import AttendanceModal from "./modal/attendance-modal.vue";

export default {
  name: "AttendancePage",
  components: {
    Header,
    SubmitAttendanceModal,
    EventModal,
    DataTable,
    ModalFilter,
    AttendanceModal,
  },
  mixins: [logic],
};
</script>

<style scoped>
:deep(.mx-input) {
  height: 38px;
  font-size: 0.9375rem;
}

.attendance-card {
  border: 1px solid #f1d4d8;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.04);
}

.attendance-toolbar {
  align-items: end;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(320px, 1.4fr) minmax(160px, 0.45fr) minmax(260px, 0.8fr) auto;
}

.filter-group {
  min-width: 0;
}

.filter-label {
  color: #344054;
  display: block;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 6px;
}

.date-range {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
}

.date-separator {
  color: #8a9bb8;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.clear-button {
  height: 38px;
  white-space: nowrap;
}

@media (max-width: 1199.98px) {
  .attendance-toolbar {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 767.98px) {
  .attendance-toolbar {
    grid-template-columns: 1fr;
  }

  .date-range {
    grid-template-columns: 1fr;
  }

  .date-separator {
    display: none;
  }
}
</style>
